<template>

  <Switchin />

</template>

<script>
import Switchin from '../components/pratiche/Switchin.vue'

export default {
  components: {
    Switchin

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
